import React from 'react';
import { renderComponent } from 'utils/commonUtils';
import SubFolderList from './SubFolderList';

const SubFolders = () => {
  return renderComponent(<SubFolderList />);
};

export default SubFolders;
